import { action } from 'mobx'
import BaseStore from '@store/table'
import { message, Modal } from 'hljd'
import Api from '@api/yun_xuan/potentialCustomersApi'
class Store extends BaseStore {
  $listApi = Api.getPushList
  @action
  delPush = id => () => {
    Modal.confirm({
      title: '是否确认删除？',
      onOk: async () => {
        const { success } = await Api.delPush({ id })
        if (success) {
          this.$getList()
          message.success('删除成功')
        }
      }
    })
  }
}

export default Store
